class WishlistPageCtrl {
  /* @ngInject */
  constructor(wishlistService) {
    this.wishlistService = wishlistService;
  }
  $onInit() {
    this.countObj = this.wishlistService.getCountObj();
  }
}
WishlistPageCtrl.$inject = ["wishlistService"];
export default WishlistPageCtrl;